import { DialogContent, DialogTitle, Stack } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"

export function RolesDialog({ role }) {
    return (
        <DataInputDialog initialValue={role} okCaption="Create">
            <DialogTitle data-cy="role-dialog-title">Role Dialog</DialogTitle>
            <DialogContent>
                <Stack sx={{ mt: 2 }} spacing={2}>
                    <BoundTextField field="name" label="Name" />
                </Stack>
            </DialogContent>
        </DataInputDialog>
    )
}
